<template>
    <el-select
        placeholder="電話區號"
        :size="'default'"
        filterable
        v-model="value"
        @change="changeSelect"
    >
        <el-option
                v-for="item in areaList"
                :key="item.code"
                :label="`${item.code} ${item.cn}`"
                :value="item.code"
        />
    </el-select>
</template>

<script setup>
    import {toRef, onMounted, ref, watch} from 'vue'
    import { getAreaList } from '@/util/areaNumber'

    const props = defineProps(['modelValue'])
    const emits = defineEmits(['update:modelValue', 'change'])

    const areaList = toRef(getAreaList())

    const value = ref(null)

    function changeSelect(e){
        emits('update:modelValue', e)
        emits('change', e)
    }

    watch(() => props.modelValue, (newValue, oldValue) => {
        value.value = newValue
    })

    onMounted(() => {
        value.value = props.modelValue
    })

</script>

<style scoped>

</style>